import { action, makeObservable, observable } from "mobx";

class RoundTimeStore {
  time = null;

  betShopTime = null;

  constructor() {
    makeObservable(this, {
      betShopTime: observable,
      time: observable,
      setTime: action.bound,
      setBetShopTime: action.bound,
    });
  }

  setBetShopTime(time) {
    this.betShopTime = time;
  }

  setTime(time){
    this.time = time;
  }

}

export const roundTimeStore = new RoundTimeStore();
